import React from "react"

import { withTranslation } from "../../../i18n/translate"
import { DynamicPdfFile } from "../../dynamic-pdf-file/dynamic-pdf-file"
import TextWithImageHero from "../../page-heros/text-with-image-hero"
import RichText from "../../rich-text/rich-text"
import StudiesAndTrainingDownloadsGrid from "../studies-and-training-downloads-grid/studies-and-training-downloads-grid"
import "./munzing-as-employer-header.sass"

class MunzingAsEmployerHeader extends React.Component {
  render() {
    const { t, topInnovatorThumbnail, topInnovator } = this.props

    return (
      <TextWithImageHero
        titleTranslatedString={t("CAREER-MUNZING_AS_EMPLOYER-HERO_TITLE")}
        textTranslationKey={"CAREER-MUNZING_AS_EMPLOYER-HERO_SUBTITLE"}
      >
        <div style={{ width: "8rem" }}>
          <DynamicPdfFile
            customClass={"_fp-munzing-as-employer-header__pdf"}
            pdf={topInnovator}
            thumbnail={topInnovatorThumbnail}
          />
        </div>
      </TextWithImageHero>
    )
  }
}

MunzingAsEmployerHeader.propTypes = {}

export default withTranslation()(MunzingAsEmployerHeader)
